const awsmobile = {
    Auth: {
        Cognito: {
            userPoolId: process.env.VUE_APP_USER_POOL_ID,
            userPoolClientId: process.env.VUE_APP_USER_POOL_WEB_CLIENT_ID,
        }
    }
};

export default awsmobile;
